import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Image, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import NavBar from "../../../NavBar";
import { useNavigate } from "react-router-dom";

const Gallery = () => {
    const navigate = useNavigate();
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const fileInputRef = useRef(null);

    const [allGallery, setAllGallery] = useState([]);
    const [categories, setCategories] = useState([]);

    const [category, setCategory] = useState("");


    const [name, setName] = useState("");
    const [file, setFile] = useState("");
    const [status, setStatus] = useState("");
    const token = localStorage.getItem("token");
    const [id, setId] = useState("");
    const maxFileSize = 3000000;


    const getAllGallery = () => {
        axios
            .get(`${BASE_URL}admin/getAllGallery`, {
                headers: {
                    "Content-Type": "Application/json",
                    "x-access-token": `${token}`,
                    "version": "1.0.0"
                }
            }).then((response) => {
                if (response.data.success == false) {
                    // toast.error(response.data.message);
                } else {
                    // toast.success(response.data.messsage);
                    setAllGallery(response.data.data);
                    console.log("response", response.data.data);
                }
            }).catch((error) => {
                console.log(error);
            })
    }

    const getAllCategory = () => {
        axios
            .get(`${BASE_URL}admin/getAllCategory`, {
                headers: {
                    "Content-Type": "Application/json",
                    "x-access-token": `${token}`,
                    "version": "1.0.0"
                }
            }).then((response) => {
                if (response.data.success == false) {
                    // toast.error(response.data.message);
                } else {
                    // toast.success(response.data.messsage);
                    setCategories(response.data.data);
                    console.log("response", response.data.data);
                }
            }).catch((error) => {
                console.log(error);
            })
    }




    const AddGallery = () => {
        // console.log(file[0].size);

        if (!file[0]) {
            toast.error("kindly select image for slider");
            return;
        }
        if (file[0].size > maxFileSize) {
            toast.error("uploaded image is too large");
            return;
        }


        const formData = new FormData();
        
        formData.append("category_id", category);
        formData.append("name", name);
        formData.append("status", status);
        formData.append("image", file[0]);

        axios
            .post(`${BASE_URL}admin/addGallery`, formData, {
                headers: {
                    "Content-Type": "multipart/formdata",
                    "version": "1.0.0",
                    "x-access-token": `${token}`
                }
            }).then((response) => {
                if (response.data.success == false) {
                    toast.error(response.data.message);
                }
                else {
                    toast.success(response.data.message);
                    getAllGallery();
                    setId("");
                    setName("");
                    setStatus("");
                    fileInputRef.current.value = "";


                }
            })
    }

    useEffect(() => {
        getAllGallery();
        getAllCategory();

    }, [])


    // const updateSlider=()=>{


    //     axios
    //     .post(`${BASE_URL}admin/updateSlider/${id}`)
    // }

    const delGallery = (id) => {
        if (window.confirm("Do you really want to delete this item?")) {

        } else {

            return;
        }
        axios
            .delete(`${BASE_URL}admin/deleteGallery/${id}`,
                {
                    headers: {
                        "Content-Type": "Application/json",
                        "version": "1.0.0",
                        "x-access-token": `${token}`
                    }
                }).then((response) => {
                    if (response.data.success == false) {
                        toast.error(response.data.message);
                    }
                    else {
                        toast.success(response.data.message);
                        getAllGallery();
                    }
                }).catch((error) => {
                    console.log(error);
                })
    }
    return (
        <>
            <NavBar />
            <div className='container '>
                <div className='row d-flex justify-content-center align-items-center mt-5'>
                    <div className='col-10 p-3 p-md-5' style={{ boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px" }}>
                        <div className="row">
                            <div>
                                <div className="dashboard mb-2 heading" style={{ fontSize: '25px' }}>
                                    Gallery

                                </div>
                            </div>

                            <div className="col-md-6">
                                <label className="formleb">Category</label>
                                {/* <input type="file" className="form-control"/> */}
                                <select className="forminp"
                                    name="category"
                                    value={category}
                                    onChange={(e) => setCategory(e.target.value)}
                                >
                                    <option>--select--</option>
                                    {categories.length > 0 && categories.map((item) => (
                                        <option value={item._id}>{item.name}</option>
                                    ))}


                                </select>

                            </div>
                            <div className="col-md-6 ">
                                <label className="formleb">Name</label>
                                <input type="text" className=" forminp form-control"
                                    name="name"
                                    placeholder="Enter name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />

                            </div>
                            <div className="col-md-6 ">
                                <label className="formleb"> Image</label>
                                <input type="file" className="forminp form-control" accept=".png , .jpeg , .jpg "
                                    name="file"
                                    ref={fileInputRef}
                                    onChange={(e) => setFile(e.target.files)}
                                />
                            </div>



                            <div className="col-md-6">
                                <label className="formleb">Status</label>
                                {/* <input type="file" className="form-control"/> */}
                                <select className="forminp"
                                    name="status"
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option>--select--</option>
                                    <option>Active</option>
                                    <option>Inactive</option>

                                </select>

                            </div>
                            <div className="col-md-6 d-flex justify-content-center align-items-center ">

                                <button type="button" className=" formbtn " onClick={() => AddGallery()} style={{ marginTop: "32px", padding: "10px", width: "100%" }}>Save</button>

                            </div>
                        </div>

                    </div>
                </div>


            </div>

            <div className="scrollit container ">
                <span style={{ fontSize: '20px', fontWeight: '600' }} className="p-2">Gallery Listing</span>
                <hr style={{ width: '165px', fontWeight: '700', color: 'grey' }}></hr>
                <div style={{ overflowX: "scroll", scrollBehavior: "smooth" }}>
                    <Table striped bordered hover >
                        <thead>
                            <tr>
                                {/* <th>#</th> */}
                                <th>Image</th>
                                <th> Name</th>
                                <th>Status</th>
                                <th>Action</th>

                            </tr>
                        </thead>
                        <tbody>

                            {allGallery.map((item, index) => (
                                <tr key={index}>

                                    <td><Image
                                        src=
                                        {item.image}
                                        style={{ width: '40px' }}></Image></td>
                                    <td>
                                        {item.name}
                                    </td>
                                    <td>
                                        {item.status}
                                    </td>
                                    <td>

                                        <button type="button" className="btn btn-primary " onClick={() => navigate('/update_gallery', { state: { item } })} ><i className="fa fa-edit"></i> </button>
                                        &nbsp; &nbsp;
                                        <button type="button" className="btn btn-danger " onClick={() => delGallery(item._id)}><i className='fa fa-trash'></i> </button>
                                    </td>
                                </tr>

                            ))
                            }


                        </tbody>
                    </Table>
                </div>

            </div>

        </>

    );
}
export default Gallery;